import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { useLocation } from "react-router-dom";
import { Container, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import Loader2 from "../DashboardPages/DashboardComponents/Loader/Loader2";
import "bootstrap/dist/css/bootstrap.min.css";
import "./activeaccount.css";
import { API_URL } from "../Api/config";

function Forgetpassword() {
  const [apicall, setApicall] = useState(false);
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [serverSideError, setServerSideError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
 
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const key = queryParams.get("key");
  const user_id = queryParams.get("iv");


  const handleSubmit = (event) => {
    setApicall(true);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setApicall(false);
    } else {
      event.preventDefault();

      if (password !== confirmPassword) { 
        alert("Password and confirm password not match.");
        return false;
      }

      axios.post(API_URL + 'user/updateforgetpassword', {
        user_id: user_id,
        password: password
      }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          if (response.data.status !== true) {
            setServerSideError(response.data.data);
          } else {
            window.location.href = "/";
          }
        })
        .catch(error => {
          console.log("error", error); 
          setServerSideError(error.response.data); 
        })

    }

    setValidated(true);
  };

  return isLoading ? (
    <Loader2 />
  ) : (
    <div
      style={{
        backgroundColor: "#272a31",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container
        className="text-white"
        style={{
          maxWidth: "500px",
          backgroundColor: "#1e2025",
          padding: "2rem",
          borderRadius: "10px",
        }}
      >
        <div className="text-center mb-4">
          <img
            src={require("../assets/images/logo_text.png")}
            style={{ width: "60%" }}
            alt="Logo"
          />
        </div>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group controlId="formPassword" className="mb-3">
            <Form.Control
              type="password"
              placeholder="Password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="formConfirmPassword" className="mb-4">
            <Form.Control
              type="password"
              placeholder="Confirm Password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Form.Group>
          {serverSideError && (
            <div className="text-danger mb-3">{serverSideError}</div>
          )}
          <Button variant="success" type="submit" className="w-100">
            {apicall ? (
              <Spinner animation="border" size="sm" className="border-black"/> 
            ) : (
              "Reset Password"
            )}
          </Button>
        </Form>
      </Container>
    </div>
  );
}

export default Forgetpassword;
